import { render, staticRenderFns } from "./PunchesOverlay.vue?vue&type=template&id=41efc0bc&scoped=true"
import script from "./PunchesOverlay.vue?vue&type=script&lang=js"
export * from "./PunchesOverlay.vue?vue&type=script&lang=js"
import style0 from "./PunchesOverlay.vue?vue&type=style&index=0&id=41efc0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41efc0bc",
  null
  
)

export default component.exports